/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type SVGProps } from 'react';

type AbrPanelIconProps = SVGProps<SVGSVGElement>;

const BASE_ICON_PROPS: AbrPanelIconProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

/** 提交到提示词库：上传/归档 */
export const IconAbrSubmitToLibrary = (props: AbrPanelIconProps) => (
  <svg {...BASE_ICON_PROPS} {...props}>
    <path d="M12 3v9" />
    <path d="m8 9 4-4 4 4" />
    <path d="M4 14v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4" />
    <path d="M2 14h20" />
  </svg>
);

/** 提示词库：书本/模板库 */
export const IconAbrPromptLibrary = (props: AbrPanelIconProps) => (
  <svg {...BASE_ICON_PROPS} {...props}>
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    <path d="M8 7h8" />
    <path d="M8 11h6" />
  </svg>
);
